module.exports = __webpack_public_path__ + "img/account_circle.bab94132.svg";